/**
 * @file 开始使用页入口
 * @author wanzhongyun
 */

import React, { useCallback } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Tabs } from 'antd';

import QuickPane from './pages/quick/Quick';
import FastDeployPane from './pages/FastDeploy';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/Footer';
import ReactStickyPolyfill from '../../components/react-sticky-polyfill/ReactStickyPolyfill';

const Install: React.FC = () => {
    const match = useRouteMatch();
    const history = useHistory();
    const tabActiveKey = match.path;


    const onTabActiveKeyChange = useCallback((key: string) => {
        history.push(key);
    }, [history]
    );

    return (
        <div className="page paddle-install-page">
            <Header />
            <ReactStickyPolyfill>
                <div className="paddle-install-page-tabs-wrap">
                    <Tabs className="paddle-install-page-tabs" activeKey={tabActiveKey} onChange={onTabActiveKeyChange}>
                        <Tabs.TabPane tab="Quick Start" key="/en/install/quick"></Tabs.TabPane>
                        <Tabs.TabPane tab="FastDeploy Quick Start" key="/en/install/FastDeploy"></Tabs.TabPane>
                    </Tabs>
                </div>
            </ReactStickyPolyfill>
            <div className="paddle-install-page-container">
                <Tabs className="paddle-install-page-tabs-body" activeKey={tabActiveKey} animated={false}>
                    <Tabs.TabPane tab="Quick Start" key="/en/install/quick">
                        <QuickPane />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="FastDeploy Quick Start" key="/en/install/FastDeploy">
                        <FastDeployPane />
                    </Tabs.TabPane>
                </Tabs>
            </div>
            <Footer />
        </div>
    );
};

export default Install;
